/* EB Test-Buy-Box - Verhalten. Gehoert zu sections/eb-pdp-buybox.liquid. */
(function(){
  "use strict";

  function initBuyBox(root){
    if (!root || root.getAttribute("data-eb-ready") === "1") { return; }
    root.setAttribute("data-eb-ready", "1");

    /* --- Optionskarten --- */
    var vidInput = root.querySelector("[data-eb-vid]");
    var totalEl  = root.querySelector("[data-eb-total]");
    var addBtn   = root.querySelector("[data-eb-add]");
    var form     = root.querySelector("form[action*='/cart/add']");
    var errEl    = root.querySelector("[data-eb-err]");
    var hintEl   = root.querySelector("[data-eb-express-hint]");
    var qtyField = root.querySelector("[data-eb-qty-field]");
    var bulkWrap = root.querySelector("[data-eb-bulk]");
    var bulkIn   = root.querySelector("[data-eb-qty-input]");
    var bulkOut  = root.querySelector("[data-eb-bulk-out]");
    var bulkAsk  = root.querySelector("[data-eb-bulk-ask]");
    var qtyMinus = root.querySelector("[data-eb-qty-minus]");
    var qtyPlus  = root.querySelector("[data-eb-qty-plus]");
    var soldOut  = addBtn ? addBtn.disabled : false;
    var logoGrp  = root.querySelector("[data-eb-logo]");
    var fileWrap = root.querySelector("[data-eb-files]");
    var filePick = root.querySelector("[data-eb-file-pick]");
    var fileSlots = root.querySelectorAll("[data-eb-file-slot]");
    var fileList = root.querySelector("[data-eb-file-list]");
    /* Ohne DataTransfer laesst sich keine FileList setzen - dann nur eine Datei. */
    var noDT = (typeof DataTransfer === "undefined");
    var maxBytes = parseInt(root.getAttribute("data-eb-maxbytes"), 10) || 20971520;
    var locWarnEl = root.querySelector("[data-eb-loc-warn]");
    var locNeeded = 1;

    function showErr(msg){
      if (!errEl) { return; }
      errEl.textContent = msg;
      errEl.hidden = false;
    }
    function hideErr(){
      if (errEl) { errEl.hidden = true; }
    }
    function okOrThrow(r){
      if (!r.ok) { throw new Error("cart/add fehlgeschlagen"); }
      return r;
    }

    var bulkMin = bulkIn ? parseInt(bulkIn.getAttribute("min"), 10) : 5;
    var bulkMax = bulkIn ? parseInt(bulkIn.getAttribute("max"), 10) : 500;
    var tiers = [];
    root.querySelectorAll("[data-eb-tier]").forEach(function(t){
      tiers.push({
        min: parseInt(t.getAttribute("data-min"), 10),
        vid: t.getAttribute("data-vid"),
        cents: parseInt(t.getAttribute("data-cents"), 10)
      });
    });
    tiers.sort(function(a, b){ return a.min - b.min; });

    /* --- Betraege im Shop-Format ausgeben (aus shop.money_format) --- */
    var OB = "{" + "{";
    var CB = "}" + "}";
    var moneyFmt = root.getAttribute("data-eb-money") || (OB + "amount" + CB);
    function groupAmount(cents, decSep, thouSep, decimals){
      var neg = cents < 0;
      var s = (Math.abs(cents) / 100).toFixed(decimals);
      var parts = s.split(".");
      var whole = parts[0];
      var out = "";
      var c = 0;
      for (var i = whole.length - 1; i >= 0; i--) {
        out = whole.charAt(i) + out;
        c++;
        if (c % 3 === 0 && i > 0) { out = thouSep + out; }
      }
      if (decimals > 0) { out = out + decSep + parts[1]; }
      return (neg ? "-" : "") + out;
    }
    function money(cents){
      var v = moneyFmt;
      v = v.split(OB + "amount_no_decimals_with_comma_separator" + CB).join(groupAmount(cents, ",", ".", 0));
      v = v.split(OB + "amount_with_comma_separator" + CB).join(groupAmount(cents, ",", ".", 2));
      v = v.split(OB + "amount_no_decimals" + CB).join(groupAmount(cents, ".", ",", 0));
      v = v.split(OB + "amount" + CB).join(groupAmount(cents, ".", ",", 2));
      return v;
    }

    function addonCents(){
      var o = root.querySelector('.eb-opt[data-eb-grp="fin"].eb-sel[data-eb-addon]');
      var c = o ? parseInt(o.getAttribute("data-eb-addon-cents"), 10) : 0;
      return isNaN(c) ? 0 : c;
    }
    function isCustom(){
      var sel = root.querySelector('.eb-opt[data-eb-grp="qty"].eb-sel');
      return !!(sel && sel.hasAttribute("data-eb-custom"));
    }
    function tierFor(q){
      var t = null;
      for (var i = 0; i < tiers.length; i++) {
        if (q >= tiers[i].min) { t = tiers[i]; }
      }
      return t;
    }
    function bulkState(){
      var q = bulkIn ? parseInt(bulkIn.value, 10) : 0;
      if (isNaN(q)) { q = 0; }
      if (q > bulkMax) { return { q: q, over: true, tier: null }; }
      if (q < bulkMin) { return { q: q, under: true, tier: null }; }
      return { q: q, tier: tierFor(q) };
    }

    /* Wie viele Aufsteller sind aktuell gewaehlt? */
    function selectedUnits(){
      if (isCustom()) {
        var st = bulkState();
        return st.tier ? st.q : 0;
      }
      var sel = root.querySelector('.eb-opt[data-eb-grp="qty"].eb-sel[data-eb-units]');
      return sel ? (parseInt(sel.getAttribute("data-eb-units"), 10) || 1) : 1;
    }

    /* Einzige Stelle, die ueber den Kaufen-Button entscheidet:
       ausverkauft, ungueltige Freimenge oder weniger Aufsteller als Standorte. */
    function updateCta(){
      var block = soldOut;
      var units = selectedUnits();
      if (isCustom() && !bulkState().tier) { block = true; }
      var tooFew = units > 0 && locNeeded > units;
      if (locWarnEl) {
        if (tooFew) {
          locWarnEl.textContent = "Du hast " + locNeeded + " Standorte angegeben und brauchst dafür mindestens " +
            locNeeded + " Aufsteller. Aktuell gewählt: " + units + ".";
          locWarnEl.hidden = false;
        } else {
          locWarnEl.hidden = true;
        }
      }
      if (tooFew) { block = true; }
      if (addBtn) { addBtn.disabled = block; }
    }

    /* Formularfelder mitfuehren, damit auch ein Submit ohne JS-Abfang korrekt ist. */
    function syncFormFields(){
      if (!vidInput) { return; }
      if (isCustom()) {
        var st = bulkState();
        if (st.tier) {
          vidInput.value = st.tier.vid;
          if (qtyField) { qtyField.value = st.q; }
        }
        return;
      }
      var sel = root.querySelector('.eb-opt[data-eb-grp="qty"].eb-sel[data-eb-variant]');
      if (sel) { vidInput.value = sel.getAttribute("data-eb-variant"); }
      if (qtyField) { qtyField.value = 1; }
    }

    function paintBulk(){
      if (!bulkWrap) { updateCta(); return; }
      var custom = isCustom();
      bulkWrap.hidden = !custom;
      if (!custom) { updateCta(); return; }
      var st = bulkState();
      if (st.over) {
        bulkOut.textContent = "Ab " + (bulkMax + 1) + " Stück machen wir dir ein individuelles Angebot.";
        bulkAsk.hidden = false;
      } else if (!st.tier) {
        bulkOut.textContent = "Mindestmenge " + bulkMin + " Stück.";
        bulkAsk.hidden = true;
      } else {
        bulkOut.innerHTML = st.q + " Stück &middot; " + money(st.tier.cents) +
          " pro Stück &middot; <strong>" + money(st.q * st.tier.cents) + "</strong>";
        bulkAsk.hidden = true;
      }
      if (qtyMinus) { qtyMinus.disabled = st.q <= bulkMin; }
      if (qtyPlus) { qtyPlus.disabled = st.q >= bulkMax; }
      updateCta();
    }

    /* Ist eine Ausfuehrung mit Aufpreis gewaehlt? Liefert die Varianten-ID oder null. */
    function addonId(){
      var o = root.querySelector('.eb-opt[data-eb-grp="fin"].eb-sel[data-eb-addon]');
      return o ? o.getAttribute("data-eb-addon") : null;
    }

    /* Gratis-Zugabe. Wie viele Stueck es gibt, haengt an der gewaehlten Menge.
       Die Konfiguration kommt aus dem Abschnitt eb-gift, damit diese Datei
       nichts ueber die konkrete Aktion wissen muss und ohne ihn unveraendert
       weiterlaeuft. */
    function giftItem(){
      var cfg = document.querySelector("[data-eb-gift-cfg]");
      if (!cfg || !addonId()) { return null; }
      var vid = cfg.getAttribute("data-eb-gift-vid");
      if (!vid) { return null; }
      var map;
      try { map = JSON.parse(cfg.getAttribute("data-eb-gift-map") || "{}"); }
      catch (e) { return null; }
      var units = selectedUnits();
      var q = map[String(units)];
      if (q === undefined) { q = cfg.getAttribute("data-eb-gift-other"); }
      q = parseInt(q, 10);
      if (!q || q < 1) { return null; }
      var item = { id: vid, quantity: q };
      var label = cfg.getAttribute("data-eb-gift-prop");
      var value = cfg.getAttribute("data-eb-gift-propval");
      if (label && value) {
        item.properties = {};
        item.properties[label] = value;
      }
      return item;
    }

    /* Buttontext: Gesamtpreis mit oder ohne Aufpreis, beide in Liquid vorformatiert. */
    function paintTotal(){
      if (!totalEl) { return; }
      if (isCustom()) {
        var st = bulkState();
        if (!st.tier) { totalEl.innerHTML = "&mdash;"; return; }
        totalEl.innerHTML = money(st.q * st.tier.cents + addonCents());
        return;
      }
      var sel = root.querySelector('.eb-opt[data-eb-grp="qty"].eb-sel');
      if (!sel) { return; }
      var withAddon = sel.getAttribute("data-eb-price-addon");
      totalEl.innerHTML = (addonId() && withAddon) ? withAddon : sel.getAttribute("data-eb-price");
    }

    /* Der Express-Checkout umgeht das Formular und kann den Aufpreis nicht mitnehmen. */
    function syncExpress(){
      var on = !!addonId();
      var pb = root.querySelector(".shopify-payment-button");
      if (pb) { pb.style.display = on ? "none" : ""; }
      if (hintEl) { hintEl.hidden = !on; }
    }

    /* Logo-Block gehoert zur Veredelung: nur dann sichtbar und nur dann mitsenden. */
    function logoMode(){
      var sel = root.querySelector('.eb-opt[data-eb-grp="logo"].eb-sel');
      return sel ? sel.getAttribute("data-eb-logo-mode") : "now";
    }
    function syncLogo(){
      if (!logoGrp) { return; }
      var on = !!addonId();
      logoGrp.hidden = !on;
      var wantFiles = on && logoMode() === "now";
      if (fileWrap) { fileWrap.hidden = !wantFiles; }
      root.querySelectorAll("[data-eb-logo] input").forEach(function(el){
        if (el.type !== "file") { el.disabled = !on; return; }
        var isSlot = el.hasAttribute("data-eb-file-slot");
        el.disabled = !wantFiles || (isSlot && noDT);
      });
    }

    root.querySelectorAll(".eb-opt").forEach(function(opt){
      opt.addEventListener("click", function(){
        if (opt.classList.contains("eb-off")) { return; }
        var grp = opt.getAttribute("data-eb-grp");
        root.querySelectorAll('.eb-opt[data-eb-grp="' + grp + '"]').forEach(function(o){
          o.classList.remove("eb-sel");
        });
        opt.classList.add("eb-sel");
        var input = opt.querySelector("input");
        if (input) { input.checked = true; }

        if (grp === "qty") {
          var vid = opt.getAttribute("data-eb-variant");
          if (vid) {
            try {
              var u = new URL(window.location.href);
              u.searchParams.set("variant", vid);
              window.history.replaceState({}, "", u.toString());
            } catch (e) { /* URL nicht aktualisierbar - unkritisch */ }
          }
        }
        paintBulk();
        syncFormFields();
        paintTotal();
        syncExpress();
        syncLogo();
      });
    });

    /* Ein sichtbares Feld, zwei versteckte Slots: Shopify speichert je Notiz nur eine Datei. */
    function setSlotFile(slot, file){
      var dt = new DataTransfer();
      if (file) { dt.items.add(file); }
      slot.files = dt.files;
    }
    function renderFileList(files){
      if (!fileList) { return; }
      fileList.innerHTML = "";
      if (!files.length) { fileList.hidden = true; return; }
      files.forEach(function(f){
        var li = document.createElement("li");
        li.textContent = f.name;
        fileList.appendChild(li);
      });
      fileList.hidden = false;
    }
    function clearPicked(){
      if (!noDT) { fileSlots.forEach(function(s){ setSlotFile(s, null); }); }
      renderFileList([]);
      if (filePick) { filePick.value = ""; }
    }
    if (filePick && noDT && fileSlots.length > 0) {
      /* Aelterer Browser: das sichtbare Feld wird selbst zur Bestellnotiz, nur eine Datei. */
      filePick.removeAttribute("multiple");
      filePick.setAttribute("name", fileSlots[0].getAttribute("name"));
    }
    if (filePick) {
      filePick.addEventListener("change", function(){
        var picked = Array.prototype.slice.call(filePick.files || []);
        var maxFiles = noDT ? 1 : fileSlots.length;
        if (picked.length > maxFiles) {
          showErr("Bitte höchstens " + maxFiles + " Dateien auswählen.");
          clearPicked();
          return;
        }
        var i;
        for (i = 0; i < picked.length; i++) {
          if (picked[i].size > maxBytes) {
            showErr("Die Datei " + picked[i].name + " ist zu gross. Erlaubt sind bis zu " +
                    Math.round(maxBytes / 1048576) + " MB pro Datei.");
            clearPicked();
            return;
          }
        }
        hideErr();
        if (!noDT) {
          fileSlots.forEach(function(s, idx){ setSlotFile(s, picked[idx] || null); });
        }
        renderFileList(picked);
      });
    }

    /* --- Veredelung: als eigene, einmalige Warenkorbposition mitschicken ---
       Warenkorb-Apps (z. B. Opus Cart Drawer) haengen sich in der Capture-Phase
       ans Formular und wuerden nur die Formularposition anlegen. Deshalb fangen
       wir eine Stufe hoeher ab: Capture am Dokument laeuft vor allem anderen. */
    var busy = false;

    function takeOver(e){
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) { e.stopImmediatePropagation(); }
      if (busy) { return; }
      busy = true;
      submitWithAddon(addonId());
    }

    if (form) {
      document.addEventListener("click", function(e){
        if (!addBtn || busy || !addonId()) { return; }
        var t = e.target;
        if (!t || !t.closest || t.closest("[data-eb-add]") !== addBtn) { return; }
        takeOver(e);
      }, true);

      document.addEventListener("submit", function(e){
        if (e.target !== form || busy || !addonId()) { return; }
        takeOver(e);
      }, true);
    }

    function submitWithAddon(aid){
        hideErr();
        if (addBtn) { addBtn.disabled = true; }

        /* Zuerst der Aufpreis, danach die Hauptposition. Faellt der zweite Schritt aus,
           steht nur der Aufpreis im Warenkorb - das sieht der Kunde sofort. */
        fetch("/cart.js", { headers: { "Accept": "application/json" } })
          .then(function(r){ return r.json(); })
          .then(function(cart){
            /* Aufpreis nur einmal: schon im Warenkorb? Dann nicht erneut hinzufuegen. */
            var have = (cart.items || []).some(function(i){
              return String(i.variant_id) === String(aid);
            });
            if (have) { return null; }
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", "Accept": "application/json" },
              body: JSON.stringify({ items: [{ id: aid, quantity: 1 }] })
            }).then(okOrThrow);
          })
          .then(function(){
            /* FormData statt JSON: nur so gehen hochgeladene Logos mit. */
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Accept": "application/json" },
              body: new FormData(form)
            }).then(okOrThrow);
          })
          .then(function(){
            /* Gratis-Zugabe als eigene Position mit 0,00 EUR, nach der Hauptposition,
               damit sie im Warenkorb darunter steht. Schlaegt sie fehl, soll die
               Bestellung trotzdem zustande kommen: der Fehler wird hier abgefangen
               und nicht weitergereicht. Auf der Bestellung steht die Ausfuehrung,
               die Zugabe faellt beim Packen also auf. */
            var gift = giftItem();
            if (!gift) { return null; }
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", "Accept": "application/json" },
              body: JSON.stringify({ items: [gift] })
            }).catch(function(){ return null; });
          })
          .then(function(){
            /* Warenkorb-Schublade der App oeffnen: ein Klick auf das Warenkorb-Symbol,
               denn genau darauf hoert sie. Gibt es das Symbol nicht, wird normal
               zur Warenkorbseite gewechselt. */
            var icon = document.querySelector("#cart-icon-bubble") ||
                       document.querySelector("a[href='/cart']");
            if (icon) {
              busy = false;
              updateCta();
              icon.click();
              return;
            }
            window.location.href = "/cart";
          })
          .catch(function(){
            /* Kein stiller Fallback - sonst landet die Bestellung ohne Aufpreis im Warenkorb. */
            busy = false;
            updateCta();
            showErr("Der Warenkorb konnte nicht aktualisiert werden. Bitte lade die Seite neu und versuche es noch einmal.");
          });
    }

    /* Zaehler: um eins hoch oder runter, immer innerhalb der Grenzen. */
    function nudgeQty(delta){
      if (!bulkIn) { return; }
      var q = parseInt(bulkIn.value, 10);
      if (isNaN(q)) { q = bulkMin; }
      q = q + delta;
      if (q < bulkMin) { q = bulkMin; }
      if (q > bulkMax) { q = bulkMax; }
      bulkIn.value = q;
      paintBulk();
      syncFormFields();
      paintTotal();
    }
    if (qtyMinus) {
      qtyMinus.addEventListener("click", function(){ nudgeQty(-1); });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener("click", function(){ nudgeQty(1); });
    }

    if (bulkIn) {
      ["input", "change"].forEach(function(ev){
        bulkIn.addEventListener(ev, function(){
          paintBulk();
          syncFormFields();
          paintTotal();
        });
      });
      bulkIn.addEventListener("keydown", function(ev){
        if (ev.key === "Enter") { ev.preventDefault(); }
      });
    }

    paintBulk();
    syncFormFields();
    paintTotal();
    syncExpress();
    syncLogo();

    /* --- Standorte ---
       Eigenes Places-Autocomplete statt dem aus theme.liquid: das haengt sich nur an ein
       einziges Feld und schreibt in eine einzige Place-ID. Unsere Felder tragen
       data-ebac="1", damit das Theme-Skript sie ueberspringt. */
    var locWrap = root.querySelector("[data-eb-locations]");
    if (locWrap) {
      var locRows   = locWrap.querySelectorAll("[data-eb-loc]");
      var locNum    = locWrap.querySelector("[data-eb-loc-num]");
      var locMinus  = locWrap.querySelector("[data-eb-loc-minus]");
      var locPlus   = locWrap.querySelector("[data-eb-loc-plus]");
      var locCntFld = locWrap.querySelector("[data-eb-loc-count]");
      var locOver   = locWrap.querySelector("[data-eb-loc-over]");
      var locMax    = parseInt(locWrap.getAttribute("data-eb-loc-max"), 10) || 10;
      var mapsKey   = locWrap.getAttribute("data-eb-maps-key") || "";
      var countries = (locWrap.getAttribute("data-eb-maps-countries") || "")
        .split(",")
        .map(function(x){ return x.trim().toLowerCase(); })
        .filter(function(x){ return x.length > 0; });
      var locCount = 1;

      function mapsReady(){
        return !!(window.google && window.google.maps && window.google.maps.places);
      }
      function withMaps(cb){
        if (mapsReady()) { cb(); return; }
        if (!mapsKey) { return; }
        if (window.__ebMapsLoading) {
          var iv = setInterval(function(){ if (mapsReady()) { clearInterval(iv); cb(); } }, 200);
          return;
        }
        window.__ebMapsLoading = true;
        var sc = document.createElement("script");
        sc.src = "https://maps.googleapis.com/maps/api/js?key=" + encodeURIComponent(mapsKey) +
                 "&libraries=places&language=de&region=DE";
        sc.async = true;
        sc.onload = cb;
        document.head.appendChild(sc);
      }
      function attachRow(row){
        var inp = row.querySelector("[data-eb-loc-input]");
        if (!inp || inp.getAttribute("data-eb-auto") === "1" || !mapsReady()) { return; }
        inp.setAttribute("data-eb-auto", "1");
        var opts = { fields: ["place_id", "name", "address_components"], types: ["establishment"] };
        if (countries.length > 0) { opts.componentRestrictions = { country: countries }; }
        var ac = new google.maps.places.Autocomplete(inp, opts);
        ac.addListener("place_changed", function(){
          var pl = ac.getPlace();
          if (!pl || !pl.place_id) { return; }
          var city = "";
          (pl.address_components || []).forEach(function(comp){
            if (comp.types.indexOf("locality") > -1) { city = comp.long_name; }
          });
          inp.value = pl.name + (city ? ", " + city : "");
          var hid = row.querySelector("[data-eb-loc-id]");
          if (hid) { hid.value = pl.place_id; }
          var msg = row.querySelector("[data-eb-loc-msg]");
          if (msg) {
            msg.textContent = "✓ Standort gefunden: " + pl.name;
            msg.hidden = false;
          }
        });
      }
      function syncLocations(){
        locRows.forEach(function(row, idx){
          var on = (idx + 1) <= locCount;
          row.hidden = !on;
          /* Ausgeblendete Zeilen abschalten, sonst landen leere Bestellnotizen im Warenkorb. */
          row.querySelectorAll("input").forEach(function(el){ el.disabled = !on; });
          if (on) { attachRow(row); }
        });
        if (locNum) { locNum.textContent = locCount; }
        if (locCntFld) { locCntFld.value = locCount; }
        if (locMinus) { locMinus.disabled = locCount <= 1; }
        if (locPlus) { locPlus.disabled = locCount >= locMax; }
        if (locOver) { locOver.hidden = locCount < locMax; }
        locNeeded = locCount;
        updateCta();
      }
      if (locPlus) {
        locPlus.addEventListener("click", function(){
          if (locCount < locMax) { locCount++; syncLocations(); }
        });
      }
      if (locMinus) {
        locMinus.addEventListener("click", function(){
          if (locCount > 1) { locCount--; syncLocations(); }
        });
      }
      syncLocations();
      withMaps(syncLocations);
    }

    /* --- Galerie-Punkte --- */
    var track = root.querySelector("[data-eb-track]");
    var dots  = root.querySelector("[data-eb-dots]");
    if (track && dots) {
      var slides = track.querySelectorAll(".eb-slide");
      slides.forEach(function(_, i){
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", "Bild " + (i + 1));
        if (i === 0) { b.setAttribute("aria-current", "true"); }
        b.addEventListener("click", function(){
          track.scrollTo({ left: track.clientWidth * i, behavior: "smooth" });
        });
        dots.appendChild(b);
      });

      /* Pfeile: am Desktop klickt man, statt zu wischen. Nur bei mehr als einem
         Bild - sonst waeren sie funktionslos. Sie landen in .eb-gal, das ist
         der positionierte Vorfahr. */
      if (slides.length > 1 && track.parentNode) {
        ["prev", "next"].forEach(function(dir){
          var b = document.createElement("button");
          b.type = "button";
          b.className = "eb-arrow eb-arrow-" + dir;
          b.setAttribute("aria-label", dir === "prev" ? "Vorheriges Bild" : "Nächstes Bild");
          b.innerHTML = dir === "prev"
            ? '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 4 7 12l8 8"></path></svg>'
            : '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 4l8 8-8 8"></path></svg>';
          b.addEventListener("click", function(){
            var i = Math.round(track.scrollLeft / track.clientWidth);
            i = (dir === "prev") ? i - 1 : i + 1;
            if (i < 0) { i = slides.length - 1; }
            if (i > slides.length - 1) { i = 0; }
            track.scrollTo({ left: track.clientWidth * i, behavior: "smooth" });
          });
          track.parentNode.appendChild(b);
        });
      }

      var t;
      track.addEventListener("scroll", function(){
        clearTimeout(t);
        t = setTimeout(function(){
          var i = Math.round(track.scrollLeft / track.clientWidth);
          dots.querySelectorAll("button").forEach(function(b, j){
            if (j === i) { b.setAttribute("aria-current", "true"); }
            else { b.removeAttribute("aria-current"); }
          });
        }, 60);
      });
    }

  }

  function initAll(scope){
    (scope || document).querySelectorAll("[data-eb-buybox]").forEach(initBuyBox);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function(){ initAll(); });
  } else {
    initAll();
  }
  /* Der Theme-Editor rendert Sections neu - dann erneut initialisieren. */
  document.addEventListener("shopify:section:load", function(e){ initAll(e.target); });
})();
